<!-- 新增设备页面 -->
<template>
  <div class="addVcnSystem section-main__warp">
    <div class="addVcnForm">
      <ioc-form
        :option="addVcnOption"
        v-model="addVcnData"
        @submit="submit"
        @reset-change="cancelBtn"
      ></ioc-form>
    </div>
  </div>
</template>
<script>
import { api } from "../../api";
import { Cache, Crypto } from "$utils";
export default {
  data() {
    // 校验系统名称--不能包含空格
    const checkSysName = (rule, value, callback) => {
      if (/\s/.test(value)) {
        callback(new Error(this.$t("deviceAccess.message.nospace")));
      } else {
        callback();
      }
    };

    // 校验IP
    const checkIp = (rule, value, callback) => {
      if (
        /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[1-9])\.(00?\d|1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(00?\d|1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(00?\d|1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/.test(
          value
        )
      ) {
        callback();
      } else {
        callback(new Error(this.$t("deviceAccess.message.ipformat")));
      }
    };
    // 校验域编码
    const checkField = (rule, value, callback) => {
      if (/^[0-9a-zA-Z]*$/g.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t("deviceAccess.message.numberchar")));
      }
    };
    // 校验密码
    const validatePwd = (rule, value, callback) => {
      let reg = new RegExp(
        "^(((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^\\s0-9a-zA-Z])|(?=.*[a-zA-Z])(?=.*[^\\s0-9a-zA-Z]))[^\\s]+)$"
      );
      if (!reg.test(value)) {
        callback(new Error("密码格式不正确"));
      } else {
        callback();
      }
    };
    const validateName = (rule, value, callback) => {
      let reg = new RegExp("^[a-zA-Z][0-9a-zA-Z_]+$");
      if (!reg.test(value)) {
        callback(
          new Error("必须是数字、字母、下划线，且首字符为字母；不能含特殊字符")
        );
      } else {
        callback();
      }
    };
    return {
      deviceType: "",

      // 插件选中时暴露出来的数据
      selectionData: {},
      // 查询厂家接口返回的数据
      manuData: {},
      addVcnData: {},
      addVcnOption: {
        menuPostion: "left",
        column: [
          {
            label: this.$t("deviceAccess.label.plugins"),
            prop: "pluginName",
            labelWidth: "88",
            type: "select",
            clearable: false,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.plugins"),
                trigger: "change"
              }
            ],
            change: (val) => {
              console.log("val", val);
              console.log("this.manuData", this.manuData);

              val.column.dicData.map((item) => {
                if (item.value == val.value) {
                  this.selectionData = item;
                  if (this.selectionData && this.manuData) {
                    console.log(
                      "this.selectionData.platid",
                      this.selectionData
                    );
                    this.manuData.map((item) => {
                      if (item.platId == this.selectionData.platid) {
                        this.selectionData.platName = item.platName;
                        this.selectionData.platVersion = item.platVersion;
                        this.selectionData.platid = item.platId;
                      }
                    });
                    this.$set(
                      this.addVcnData,
                      "platName",
                      this.selectionData.platName
                    );
                    if (this.selectionData.osType == 1) {
                      this.$set(this.addVcnData, "osType", "Linux");
                    } else if (this.selectionData.osType == 2) {
                      this.$set(this.addVcnData, "osType", "Windows");
                    }
                    this.$set(
                      this.addVcnData,
                      "platVersion",
                      this.selectionData.platVersion
                    );

                    if (this.selectionData.protocolType == 1) {
                      this.$set(this.addVcnData, "protocolType", "http");
                    } else if (this.selectionData.protocolType == 2) {
                      this.$set(this.addVcnData, "protocolType", "https");
                    } else if (this.selectionData.protocolType == 3) {
                      this.$set(this.addVcnData, "protocolType", "TCP/IP");
                    } else if (this.selectionData.protocolType == 4) {
                      this.$set(this.addVcnData, "protocolType", "SDK");
                    } else if (this.selectionData.protocolType == 5) {
                      this.$set(this.addVcnData, "protocolType", "UDP");
                    }

                    // this.$set(this.addVcnData,'protocolType',this.selectionData.protocolType)
                    this.$set(
                      this.addVcnData,
                      "factoryName",
                      this.selectionData.factoryName
                    );
                    this.$set(
                      this.addVcnData,
                      "platId",
                      this.selectionData.platid
                    );
                    this.addVcnData.connectionMode = "1";
                  }
                }
              });
              // this.selectionData = val.column.dicData[0]
            },
            dicData: []
          },
          {
            label: this.$t("deviceAccess.label.factory"),
            prop: "factoryName",
            labelWidth: "88",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.platname"),
            prop: "platName",
            labelWidth: "88",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.version"),
            prop: "platVersion",
            labelWidth: "88",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.os"),
            prop: "osType",
            labelWidth: "88",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.protocol"),
            prop: "protocolType",
            labelWidth: "88",
            readonly: true
          },
          {
            label: this.$t("deviceAccess.label.connection"),
            prop: "connectionMode",
            labelWidth: "88",
            type: "radio",
            border: true,
            dicData: [
              {
                label: this.$t("deviceAccess.label.platform"),
                value: "1"
              }
            ],
            span: 12,
            clearable: true,
            row: true,
            required: []
          },
          {
            label: this.$t("deviceAccess.label.systemname"),
            prop: "systemName",
            labelWidth: "88",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.systemname"),
                trigger: "blur"
              },
              { validator: checkSysName, trigger: "blur" },
              {
                min: 1,
                max: 50,
                message: this.$t("deviceAccess.message.less50"),
                trigger: "blur"
              }
            ]
          },
          {
            label: this.$t("deviceAccess.label.controlcenter"),
            prop: "areaName",
            labelWidth: "88",
            type: "select",
            clearable: true,
            change: (val) => {
              val.column.dicData.map((item) => {
                if (item.value == val.value) {
                  this.addVcnData.areaCode = item.table;
                }
              });
            },
            dicData: []
          },
          {
            label: this.$t("deviceAccess.label.ip"),
            prop: "serverIp",
            labelWidth: "88",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.ip"),
                trigger: "blur"
              },
              { validator: checkIp, trigger: "blur" }
            ]
          },
          {
            label: this.$t("deviceAccess.label.domain"),
            prop: "domainCode",
            labelWidth: "88",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.domain"),
                trigger: "blur"
              },
              { validator: checkField, trigger: "blur" }
            ]
          },
          {
            label: this.$t("deviceAccess.label.port"),
            prop: "serverPort",
            labelWidth: "88",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.port"),
                trigger: "blur"
              },
              {
                pattern:
                  /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/,
                message: this.$t("deviceAccess.message.port2"),
                trigger: "blur"
              }
            ]
          },
          {
            label: this.$t("deviceAccess.label.account"),
            prop: "serviceUsername",
            labelWidth: "88",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.account"),
                trigger: "blur"
              },
              {
                min: 4,
                max: 30,
                message: "长度在 4 到 30 个字符",
                trigger: "blur"
              },
              { validator: validateName, trigger: "blur" }
            ]
          },
          {
            label: this.$t("deviceAccess.label.password"),
            prop: "servicePassword",
            labelWidth: "88",
            type: "password",
            clearable: true,
            rules: [
              {
                required: true,
                message: this.$t("deviceAccess.message.password"),
                trigger: "blur"
              },
              {
                min: 6,
                max: 20,
                message: "长度在 6 到 20 个字符",
                trigger: "blur"
              },
              { validator: validatePwd, trigger: "blur" }
            ]
          }
        ],
        submitText: this.$t("deviceAccess.button.save"),
        emptyText: this.$t("deviceAccess.button.cancel"),
        submitIcon: "false",
        emptyIcon: "false"
      }
    };
  },
  mounted() {
    console.log("addVcnOption", this.addVcnOption);
  },
  created() {
    this.deviceType = this.$route.query.deviceType;
    this.getSelectPlugInfo();
    this.getSelectFactory();
    this.getSelectArea();
  },
  methods: {
    // 新增系统时查询控制中心
    getSelectArea() {
      this.$fetch(api.device.selectAreaInfoList, {}).then((res) => {
        const Array = [];
        res.returnObj.map((item) => {
          const data = {};
          data.table = item.areaCode;
          data.value = item.areaName;
          Array.push(data);
        });
        this.addVcnOption.column[8].dicData = Array;
      });
    },
    // 新增设备系统时，获取插件信息
    getSelectPlugInfo() {
      const params = {
        deviceType: this.deviceType
      };
      this.$fetch(api.device.selectPlugInfo, params).then((res) => {
        const Array = [];
        res.returnObj.map((item) => {
          const data = {};
          data.factoryId = item.factoryId;
          data.table = item.pluginId;
          data.platid = item.platid;
          data.osType = item.osType;
          data.value = item.pluginName;
          data.protocolType = item.protocolType;
          data.factoryName = item.factoryName;
          Array.push(data);
        });
        this.addVcnOption.column[0].dicData = Array;
      });
    },
    // 新增设备系统时，获取厂家信息
    getSelectFactory() {
      const params = {
        deviceType: this.deviceType
      };
      this.$fetch(api.device.selectFactory, params).then((res) => {
        this.manuData = res.returnObj;
      });
    },
    // 新增系统，提交数据
    submit(val) {
      let key = Cache.get("OCX_OPTIONS").key;
      // console.log('key',Cache.get("OCX_OPTIONS"));
      // console.log('val',val)
      val.deviceGroupCode = "0";
      // val.parkId = '1'
      const params = val;
      params.deviceType = this.deviceType;
      params.servicePassword = Crypto.getAesString(params.servicePassword, key);
      console.log("密匙密文" + key);
      console.log("密码密文：" + params.servicePassword);
      this.$fetch(api.device.addSystemInfo, params)
        .then((res) => {
          if (res.success === true) {
            this.$message.success(res.msgContent);
            this.$router.push({
              path: "/deviceaccess/index"
            });
          } else if (res.success === false) {
            this.$message.error(res.msgContent);
          }
        })
        .catch(() => {});
    },

    // 取消按钮
    cancelBtn() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.addVcnSystem {
  width: 100%;
  height: 100%;
  padding: 50px 0 0 50px;
}
.addVcnForm {
  float: left;
  width: 70%;
}
.section-main .section-main__content .section-main__warp {
  margin: 0 0 !important;
  background-color: #22385d;
  min-height: calc(100% - 20px);
}
.addVcnSystem .el-form-item--mini.el-form-item {
  text-align: center !important;
}
:deep .el-input--mini .el-input__inner {
  color: #e1e1e1;
}
</style>
